import { render, staticRenderFns } from "./ZoomControls.vue?vue&type=template&id=3c1f23ab&scoped=true&"
import script from "./ZoomControls.vue?vue&type=script&lang=ts&"
export * from "./ZoomControls.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomControls.vue?vue&type=style&index=0&id=3c1f23ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f23ab",
  null
  
)

export default component.exports